module.exports = __webpack_public_path__ + "img/Bent Tongue.c0843e9a.png";